/* ============================================================
   Quiz "É Coisa de Pai" — Dia dos Pais / Pé Direito
   Porte fiel do app React (campanha DP26) para JS vanilla.
   Sistema visual: azul royal + xadrez, creme/greige, periwinkle,
   pills e sombra offset chapada. Losango como único ícone e setas
   desenhadas em SVG (sem lib de ícone).
   Inicializa cada seção via [data-quiz-root] e re-inicializa no
   editor da Shopify (shopify:section:load). A integração de carrinho
   (modal de variantes + add-to-cart nativo) é específica do tema.
   ============================================================ */
(function () {
  "use strict";

  // ── Primitivos visuais da campanha ──────────────────────────
  function losango(cls) {
    return (
      '<svg class="qd-losango ' +
      (cls || "") +
      '" viewBox="0 0 95 58.598" fill="none" aria-hidden="true">' +
      '<path d="M 92.917 25.684 L 50.668 0.609 C 49.323 -0.19 47.646 -0.202 46.285 0.568 L 2.148 25.644 C -0.716 27.27 -0.716 31.334 2.148 32.96 L 46.285 58.031 C 47.642 58.802 49.323 58.785 50.668 57.991 L 92.921 32.919 C 95.693 31.277 95.693 27.327 92.921 25.684 L 92.917 25.684 Z M 47.497 44.882 C 38.736 44.882 31.635 37.908 31.635 29.304 C 31.635 20.7 38.736 13.726 47.497 13.726 C 56.258 13.726 63.359 20.7 63.359 29.304 C 63.359 37.908 56.258 44.882 47.497 44.882 Z" fill="currentColor" fill-rule="nonzero"/>' +
      "</svg>"
    );
  }

  var SETA_PATHS = {
    right: '<path d="M5 12h13"/><path d="M12.5 6l6 6-6 6"/>',
    left: '<path d="M19 12H6"/><path d="M11.5 6l-6 6 6 6"/>',
    down: '<path d="M12 5v13"/><path d="M6 12.5l6 6 6-6"/>',
    x: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
  };
  function seta(dir, cls, sw) {
    return (
      '<svg class="qd-seta ' +
      (cls || "") +
      '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' +
      (sw || 2.25) +
      '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      SETA_PATHS[dir] +
      "</svg>"
    );
  }

  function lockup(cls) {
    return (
      '<span class="qd-lockup ' +
      (cls || "") +
      '">' +
      losango("qd-lockup__mark") +
      '<span class="qd-lockup__word">PéDireito</span></span>'
    );
  }

  function pill(text, variant) {
    return (
      '<span class="qd-pill qd-pill--' +
      (variant || "perisoft") +
      '">' +
      esc(text) +
      "</span>"
    );
  }

  // ── Dados: perguntas ────────────────────────────────────────
  var P_DESTINATARIO = {
    id: "destinatario",
    tipo: "opcoes",
    prompt: "Pra quem é o presente?",
    colunas: 2,
    opcoes: [
      { valor: "pai", label: "Meu pai" },
      { valor: "sogro", label: "Meu sogro" },
      { valor: "pai_dos_filhos", label: "O pai dos meus filhos" },
      { valor: "avo", label: "Meu avô" },
    ],
  };
  var P_IDADE = {
    id: "idade",
    tipo: "opcoes",
    prompt: "Quantos anos ele tem?",
    colunas: 2,
    opcoes: [
      { valor: "menos40", label: "Menos de 40" },
      { valor: "40a55", label: "40 a 55" },
      { valor: "56a70", label: "56 a 70" },
      { valor: "mais70", label: "Mais de 70" },
    ],
  };
  var P_FILHOS_IDADE = {
    id: "filhosIdade",
    tipo: "opcoes",
    prompt: "Quantos anos têm os filhos?",
    colunas: 2,
    opcoes: [
      { valor: "pequenos", label: "Ainda pequenos" },
      { valor: "4a9", label: "Entre 4 e 9" },
      { valor: "10a15", label: "Entre 10 e 15" },
      { valor: "adultos", label: "Já são adultos" },
    ],
  };
  var P_COMO_VEEM = {
    id: "relacao",
    tipo: "opcoes",
    prompt: "Como os filhos veem ele?",
    opcoes: [
      { valor: "amigo", label: "Melhor amigo" },
      { valor: "conselheiro", label: "Conselheiro" },
      { valor: "exemplo", label: "Exemplo" },
    ],
  };
  var P_RELACAO = {
    id: "relacao",
    tipo: "opcoes",
    prompt: "O que ele é pra você?",
    opcoes: [
      { valor: "amigo", label: "Meu melhor amigo" },
      { valor: "conselheiro", label: "Meu conselheiro" },
      { valor: "exemplo", label: "Meu exemplo" },
    ],
  };
  // Ramo "O pai dos meus filhos": tempo de qualidade DELE COM OS FILHOS
  var P_TEMPO_FILHOS = {
    id: "tempoQualidade",
    tipo: "escala",
    prompt: "Nos últimos meses, como foi o tempo de qualidade dele com os filhos?",
    min: "Foi pouco",
    max: "Foi excelente",
  };
  // Demais ramos: tempo de qualidade DE VOCÊS JUNTOS
  var P_TEMPO_JUNTOS = {
    id: "tempoQualidade",
    tipo: "escala",
    prompt: "Nos últimos meses, como foi o tempo de qualidade de vocês juntos?",
    min: "Foi pouco",
    max: "Foi excelente",
  };
  var P_CAMISA = {
    id: "camisaTime",
    tipo: "escala",
    prompt: "Quanto ele gosta de camisa de time?",
    min: "Não gosta",
    max: "Gosta muito",
  };
  var P_INVESTIMENTO = {
    id: "investimento",
    tipo: "opcoes",
    prompt: "Quanto você quer caprichar no presente dele?",
    colunas: 1,
    opcoes: [
      { valor: "199", label: "O queridinho · até R$199" },
      { valor: "299", label: "Um capricho a mais · até R$299" },
      { valor: "399", label: "O melhor que tem · até R$399" },
    ],
  };

  function perguntasPara(r) {
    var ehPaiDosFilhos = r.destinatario === "pai_dos_filhos";
    var meio = ehPaiDosFilhos
      ? [P_FILHOS_IDADE, P_COMO_VEEM, P_TEMPO_FILHOS]
      : [P_RELACAO, P_TEMPO_JUNTOS];
    return [P_DESTINATARIO, P_IDADE]
      .concat(meio)
      .concat([P_CAMISA, P_INVESTIMENTO]);
  }

  // ── Dados: kits ─────────────────────────────────────────────
  var KITS = {
    kit1: {
      id: "kit1",
      nome: "Kit É Coisa de Pai 1",
      itens: ["Chinelo", "Boné Brasil"],
      preco: 180,
      precoDe: null,
      economia: null,
      escolheCor: true,
    },
    kit2: {
      id: "kit2",
      nome: "Kit É Coisa de Pai 2",
      itens: ["Boné Brasil", "Camiseta Brasil"],
      preco: 266,
      precoDe: null,
      economia: null,
      escolheCor: false,
    },
    kit3: {
      id: "kit3",
      nome: "Kit É Coisa de Pai 3",
      itens: ["Chinelo", "Boné Brasil", "Camiseta Brasil"],
      preco: 323,
      precoDe: null,
      economia: null,
      escolheCor: true,
    },
    kit4: {
      id: "kit4",
      nome: "Kit É Coisa de Pai 4",
      itens: ["Chinelo", "Boné Brasil", "Camisa 10"],
      preco: 370,
      precoDe: null,
      economia: null,
      escolheCor: true,
    },
  };

  var gostaDeCamisa = function (n) {
    return n >= 3;
  };

  function resolverKit(r) {
    var investimento = String(r.investimento == null ? "" : r.investimento);
    var camisa = Number(r.camisaTime || 0);
    switch (investimento) {
      case "199":
        return KITS.kit1;
      case "299":
        return KITS.kit2;
      case "399":
        return gostaDeCamisa(camisa) ? KITS.kit4 : KITS.kit3;
      default:
        return KITS.kit1;
    }
  }

  // ── Personalização ──────────────────────────────────────────
  var IDADE_FRAG = {
    menos40: "tem menos de 40 anos",
    "40a55": "está na faixa dos 40 aos 55",
    "56a70": "está na faixa dos 56 aos 70",
    mais70: "tem mais de 70 anos",
  };
  var FILHOS_FRAG = {
    pequenos: "ainda são pequenos",
    "4a9": "têm entre 4 e 9 anos",
    "10a15": "têm entre 10 e 15 anos",
    adultos: "já são adultos",
  };
  var RELACAO_FRAG = {
    amigo: "o melhor amigo",
    conselheiro: "o conselheiro",
    exemplo: "o exemplo",
  };

  function personalizar(r) {
    var ehPaiDosFilhos = r.destinatario === "pai_dos_filhos";
    var frases = [];
    var idade = IDADE_FRAG[String(r.idade)];
    if (idade) frases.push("Ele " + idade + ".");
    if (ehPaiDosFilhos) {
      var filhos = FILHOS_FRAG[String(r.filhosIdade)];
      if (filhos) frases.push("Os filhos " + filhos + ".");
    }
    if (r.tempoQualidade != null) {
      frases.push(
        "Nos últimos meses, o tempo de qualidade de vocês foi " +
          Number(r.tempoQualidade) +
          " de 5."
      );
    }
    var relacao = RELACAO_FRAG[String(r.relacao)];
    if (relacao) {
      frases.push(
        ehPaiDosFilhos
          ? "Pros filhos, ele é " + relacao + "."
          : "Pra você, ele é " + relacao + "."
      );
    }
    return { ehPaiDosFilhos: ehPaiDosFilhos, frases: frases };
  }

  // ── Utils ───────────────────────────────────────────────────
  var brl = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  function formatarReais(n) {
    return brl.format(Number(n) || 0);
  }
  // Preço psicológico: arredonda para baixo terminando em ,90 (370 -> 369,90).
  // Idempotente — 369,90 continua 369,90. Vale para preços; a "economia"
  // é uma diferença e continua exata.
  function preco90(n) {
    var v = Number(n) || 0;
    if (v <= 0) return 0;
    return Math.ceil(v) - 0.1;
  }
  function formatarPreco(n) {
    return formatarReais(preco90(n));
  }
  function esc(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  function pad2(n) {
    return String(n).length < 2 ? "0" + n : String(n);
  }
  function scrollTopo() {
    // Neste tema o scroll no desktop acontece no .page-wrapper (body tem
    // overflow:hidden), então rolamos também o contêiner mais próximo.
    try {
      window.scrollTo({ top: 0, behavior: "auto" });
    } catch (e) {
      window.scrollTo(0, 0);
    }
    var wrapper = document.querySelector(".page-wrapper");
    if (wrapper && typeof wrapper.scrollTo === "function") {
      wrapper.scrollTo(0, 0);
    }
    if (document.documentElement) document.documentElement.scrollTop = 0;
  }

  // ── Reveal on scroll (fade + slide, efeito in-out) ──────────
  function bindReveals(scope) {
    var nodes = scope.querySelectorAll(".qd-reveal");
    if (!nodes.length) return;
    if (!("IntersectionObserver" in window)) {
      Array.prototype.forEach.call(nodes, function (n) {
        n.classList.add("is-in");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var once = entry.target.getAttribute("data-reveal-once") === "1";
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            if (once) io.unobserve(entry.target);
          } else if (!once) {
            entry.target.classList.remove("is-in");
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -12% 0px" }
    );
    Array.prototype.forEach.call(nodes, function (n) {
      io.observe(n);
    });
  }

  // ── Controlador por seção ───────────────────────────────────
  function Quiz(root) {
    this.root = root;
    this.img = root.getAttribute("data-image") || "";
    this.alt =
      root.getAttribute("data-image-alt") ||
      "Pai e filho jogando bola na praia de chinelo Pé Direito";
    // imagem de transição (família distante); cai na imagem principal se vazia
    this.transImg = root.getAttribute("data-transition-image") || this.img;
    this.transAlt =
      root.getAttribute("data-transition-alt") ||
      "Pai e filho no sofá, cada um no seu celular, sem se conectar";
    // assets da campanha (bundle do tema)
    this.scriptCreme = root.getAttribute("data-asset-script-creme") || "";
    this.scriptAzul = root.getAttribute("data-asset-script") || "";
    this.caixa = root.getAttribute("data-asset-caixa") || "";
    this.capsula = root.getAttribute("data-asset-capsula") || "";
    this.prod = {
      amarelo: root.getAttribute("data-asset-product-amarelo") || "",
      verde: root.getAttribute("data-asset-product-verde") || "",
      azul: root.getAttribute("data-asset-product-azul") || "",
      branco: root.getAttribute("data-asset-product-branco") || "",
    };
    this.fase = "intro";
    this.respostas = {};
    this.idx = 0;
    this.adicionado = false;
    // Lê a config dos kits ANTES do 1º innerHTML — os mount* substituem
    // root.innerHTML e apagariam os <script class="qd-kit-config">.
    this.kitConfig();
    this.mountIntro();
  }

  Quiz.prototype.img_ = function (src, alt, cls, ariaHidden) {
    return (
      '<img src="' +
      esc(src) +
      '" alt="' +
      esc(alt || "") +
      '"' +
      (cls ? ' class="' + cls + '"' : "") +
      (ariaHidden ? ' aria-hidden="true"' : "") +
      " />"
    );
  };

  // ── INTRO ───────────────────────────────────────────────────
  Quiz.prototype.mountIntro = function () {
    this.fase = "intro";
    this.root.innerHTML =
      '<div class="qd-intro">' +
      '<div class="qd-intro__inner">' +
      '<div class="qd-sobe qd-intro__copy">' +
      lockup("qd-res__lockup") +
      '<div class="qd-intro__badge">' +
      pill("É coisa de pai", "perisoft") +
      "</div>" +
      '<h1 class="cp-heading qd-intro__title">o presente com a <span>cara dele</span></h1>' +
      '<p class="qd-intro__lead">Responda algumas perguntas sobre o pai que você vai presentear. A gente lê cada resposta e monta o presente certo — você não precisa escolher o kit, o quiz escolhe por você.</p>' +
      '<button type="button" class="qd-intro__cta" data-comecar>Começar o quiz' +
      seta("right") +
      "</button>" +
      '<p class="qd-intro__meta">' +
      losango() +
      " Leva menos de 1 minuto</p>" +
      "</div>" +
      '<div class="qd-sobe qd-intro__media">' +
      '<div class="qd-intro__frame">' +
      this.img_(this.img, this.alt, "qd-intro__img") +
      '<div class="qd-intro__frame-overlay"></div>' +
      this.img_(this.scriptCreme, "", "qd-intro__script", true) +
      "</div></div>" +
      "</div></div>";

    var self = this;
    this.root
      .querySelector("[data-comecar]")
      .addEventListener("click", function () {
        self.respostas = {};
        self.idx = 0;
        self.mountQuiz();
        scrollTopo();
      });
    scrollTopo();
  };

  // ── QUIZ ────────────────────────────────────────────────────
  Quiz.prototype.mountQuiz = function () {
    this.fase = "quiz";
    this.root.innerHTML =
      '<div class="qd-quiz">' +
      '<aside class="qd-quiz__aside">' +
      this.img_(this.img, this.alt, "qd-quiz__img") +
      '<div class="qd-quiz__overlay"></div>' +
      '<div class="qd-quiz__asidecontent">' +
      lockup() +
      this.img_(this.scriptCreme, "É coisa de pai", "qd-quiz__script") +
      "</div>" +
      "</aside>" +
      '<main class="qd-quiz__main">' +
      '<div class="qd-quiz__top">' +
      '<button type="button" class="qd-quiz__back" data-voltar aria-label="Voltar">' +
      seta("left") +
      "</button>" +
      '<div class="qd-quiz__track"><div class="qd-quiz__fill" data-fill></div></div>' +
      '<span class="cp-heading qd-quiz__count" data-count></span>' +
      "</div>" +
      '<div class="qd-quiz__qwrap" data-qwrap></div>' +
      "</main>" +
      "</div>";

    var self = this;
    this.root
      .querySelector("[data-voltar]")
      .addEventListener("click", function () {
        self.voltar();
      });
    this.renderQuestion();
  };

  Quiz.prototype.voltar = function () {
    if (this.idx === 0) {
      this.mountIntro();
    } else {
      this.idx -= 1;
      this.renderQuestion();
    }
  };

  Quiz.prototype.avancar = function () {
    var total = perguntasPara(this.respostas).length;
    if (this.idx + 1 >= total) {
      this.mountResultado();
      scrollTopo();
    } else {
      this.idx += 1;
      this.renderQuestion();
    }
  };

  Quiz.prototype.renderQuestion = function () {
    var perguntas = perguntasPara(this.respostas);
    var total = perguntas.length;
    var pergunta = perguntas[this.idx];
    var valorAtual = this.respostas[pergunta.id];

    var fill = this.root.querySelector("[data-fill]");
    fill.style.width = (((this.idx + 1) / total) * 100).toFixed(4) + "%";
    this.root.querySelector("[data-count]").textContent =
      this.idx + 1 + "/" + total;

    var html =
      '<div class="qd-sobe" data-question style="display:flex;flex:1 1 0%;flex-direction:column;justify-content:center">' +
      '<h2 class="cp-heading qd-quiz__question">' +
      esc(pergunta.prompt) +
      "</h2>";

    if (pergunta.tipo === "opcoes") {
      html +=
        '<div class="qd-opts' +
        (pergunta.colunas === 2 ? " qd-opts--2" : "") +
        '">';
      for (var i = 0; i < pergunta.opcoes.length; i++) {
        var op = pergunta.opcoes[i];
        var ativo = valorAtual === op.valor;
        html +=
          '<button type="button" class="qd-opt' +
          (ativo ? " is-active" : "") +
          '" data-opt="' +
          esc(op.valor) +
          '">' +
          esc(op.label) +
          seta("right") +
          "</button>";
      }
      html += "</div>";
    } else {
      html +=
        '<div class="qd-escala-wrap">' + this.escalaHTML(pergunta, valorAtual);
      var temValor = typeof valorAtual === "number";
      html +=
        '<button type="button" class="qd-continue' +
        (temValor ? "" : " is-disabled") +
        '" data-continue' +
        (temValor ? "" : " disabled") +
        ">Continuar" +
        seta("right") +
        "</button>";
      html += "</div>";
    }
    html += "</div>";

    var qwrap = this.root.querySelector("[data-qwrap]");
    qwrap.innerHTML = html;
    this.bindQuestion(pergunta);
  };

  Quiz.prototype.escalaHTML = function (pergunta, valor) {
    var html = '<div class="qd-escala"><div class="qd-escala__grid">';
    for (var n = 0; n <= 5; n++) {
      var ativo = valor === n;
      html +=
        '<button type="button" class="qd-escala__btn' +
        (ativo ? " is-active" : "") +
        '" data-escala="' +
        n +
        '" aria-pressed="' +
        (ativo ? "true" : "false") +
        '">' +
        n +
        "</button>";
    }
    html +=
      '</div><div class="qd-escala__labels"><span>' +
      esc(pergunta.min) +
      "</span><span>" +
      esc(pergunta.max) +
      "</span></div></div>";
    return html;
  };

  Quiz.prototype.bindQuestion = function (pergunta) {
    var self = this;
    var qwrap = this.root.querySelector("[data-qwrap]");

    if (pergunta.tipo === "opcoes") {
      var opts = qwrap.querySelectorAll("[data-opt]");
      Array.prototype.forEach.call(opts, function (btn) {
        btn.addEventListener("click", function () {
          self.respostas[pergunta.id] = btn.getAttribute("data-opt");
          self.avancar();
        });
      });
    } else {
      var nums = qwrap.querySelectorAll("[data-escala]");
      Array.prototype.forEach.call(nums, function (btn) {
        btn.addEventListener("click", function () {
          var n = Number(btn.getAttribute("data-escala"));
          self.respostas[pergunta.id] = n;
          Array.prototype.forEach.call(nums, function (b) {
            var on = Number(b.getAttribute("data-escala")) === n;
            b.classList.toggle("is-active", on);
            b.setAttribute("aria-pressed", on ? "true" : "false");
          });
          var cont = qwrap.querySelector("[data-continue]");
          cont.classList.remove("is-disabled");
          cont.removeAttribute("disabled");
        });
      });
      var cont = qwrap.querySelector("[data-continue]");
      cont.addEventListener("click", function () {
        if (typeof self.respostas[pergunta.id] === "number") self.avancar();
      });
    }
  };

  // ── RESULTADO ───────────────────────────────────────────────
  Quiz.prototype.faixa = function (tom, extra, inner, id) {
    return (
      '<section class="qd-faixa qd-tom-' +
      tom +
      (extra ? " " + extra : "") +
      '"' +
      (id ? ' id="' + id + '"' : "") +
      '><div class="qd-faixa__inner"><div class="qd-reveal">' +
      inner +
      "</div></div></section>"
    );
  };

  Quiz.prototype.indice = function (n) {
    return '<span class="qd-indice" aria-hidden="true">' + pad2(n) + "</span>";
  };

  Quiz.prototype.mountResultado = function () {
    this.fase = "resultado";
    this.adicionado = false;
    var kit = resolverKit(this.respostas);
    var p = personalizar(this.respostas);

    // ── Hero (royal + xadrez) ──
    var diagCard = "";
    if (p.frases.length > 0) {
      var itens = "";
      for (var i = 0; i < p.frases.length; i++) {
        itens +=
          '<li class="qd-diag__item">' +
          '<span class="qd-diag__check" aria-hidden="true"></span>' +
          this.indice(i + 1) +
          '<span class="qd-diag__text">' +
          esc(p.frases[i]) +
          "</span></li>";
      }
      diagCard =
        '<div class="qd-reveal" data-reveal-delay="150"><div class="qd-diag">' +
        '<div class="qd-diag__leaf" aria-hidden="true"></div>' +
        '<div class="qd-diag__card"><ul>' +
        itens +
        "</ul></div></div></div>";
    }

    var hero = this.faixa(
      "royal cp-checker qd-faixa--center qd-faixa--herotop",
      "",
      lockup("qd-res__lockup") +
        this.img_(this.scriptCreme, "É coisa de pai", "qd-res__script") +
        '<h1 class="cp-heading qd-res__title">a gente leu cada resposta sua. <span>e montou o presente com a cara dele.</span></h1>' +
        diagCard +
        '<div class="qd-res__pill">' +
        pill("Veja o que nós preparamos para você", "perisoft") +
        "</div>" +
        '<div class="qd-res__seta">' +
        seta("down", "qd-anim-bounce") +
        "</div>"
    );

    // ── Manifesto (greige, editorial) ──
    var manifesto = this.faixa(
      "greige qd-faixa--larga",
      "",
      '<div class="qd-manifesto">' +
        '<div class="qd-reveal qd-manifesto__col-a"><p class="cp-heading qd-manifesto__lead">A Pé Direito não é só um presente. É uma desculpa pra estar presente.</p></div>' +
        '<div class="qd-reveal qd-manifesto__col-b" data-reveal-delay="140">' +
        '<div class="qd-manifesto__rule" aria-hidden="true"></div>' +
        '<p class="qd-manifesto__text">Pra criar memória, vínculo, admiração. Porque aconteça o que acontecer, esse vínculo não se explica. É coisa de pai.</p>' +
        lockup("qd-manifesto__lockup") +
        "</div></div>"
    );

    // ── Foto full-bleed ──
    var foto =
      '<div class="qd-reveal"><section class="qd-photo">' +
      this.img_(this.img, this.alt, "qd-photo__img") +
      '<div class="qd-photo__overlay"></div>' +
      this.img_(this.scriptCreme, "É coisa de pai", "qd-photo__script") +
      "</section></div>";

    // ── Transição ──
    var transicao =
      '<div class="qd-reveal"><section class="qd-photo qd-trans">' +
      this.img_(this.transImg, this.transAlt, "qd-photo__img") +
      '<div class="qd-trans__overlay"></div>' +
      '<div class="qd-trans__foot"><div class="qd-trans__inner">' +
      '<div class="qd-trans__rule" aria-hidden="true"></div>' +
      '<p class="cp-heading qd-trans__text">Só que hoje tudo conspira contra isso.</p>' +
      "</div></div></section></div>";

    // ── Diagnóstico (royal) ──
    var linhas = [
      "Tela demais.",
      "Notificação demais.",
      "Gente demais querendo a atenção que era pra ser de vocês dois.",
    ];
    var linhasHTML = "";
    for (var l = 0; l < linhas.length; l++) {
      linhasHTML +=
        '<div class="qd-reveal" data-reveal-delay="' +
        l * 120 +
        '"><p class="qd-diagnostico__line">' +
        this.indice(l + 1) +
        esc(linhas[l]) +
        "</p></div>";
    }
    var diagnostico = this.faixa(
      "royal qd-faixa--larga",
      "",
      '<div style="margin-bottom:1.5rem">' +
        pill("O diagnóstico", "peri") +
        "</div>" +
        '<p class="cp-heading qd-diagnostico__head">O mundo aprendeu a <span>roubar o tempo</span> sem você perceber que perdeu.</p>' +
        '<div class="qd-diagnostico__list">' +
        linhasHTML +
        "</div>"
    );

    // ── Solução (creme, split) ──
    var solucao = this.faixa(
      "creme qd-faixa--larga",
      "",
      '<div class="qd-solucao">' +
        '<div class="qd-reveal">' +
        '<div style="margin-bottom:1.5rem">' +
        pill("Mas o que a Pé Direito tem a ver com isso", "perisoft") +
        "</div>" +
        '<p class="cp-heading qd-solucao__head">Essa memória entre pai e filho não se compra. Se constrói.</p>' +
        '<div class="qd-solucao__text"><p>A gente acredita que a família é presente de Deus, que filhos são herança e que o único caminho de ensinar é estar junto.</p></div>' +
        "</div>" +
        '<div class="qd-reveal" data-reveal-delay="140">' +
        '<div class="cp-checker qd-solucao__panel"><div class="qd-solucao__poster">' +
        '<div class="qd-solucao__leaf" aria-hidden="true"></div>' +
        '<div class="qd-solucao__card">' +
        this.img_(this.scriptAzul, "", "", true) +
        lockup() +
        "</div></div></div>" +
        "</div></div>"
    );

    // ── O presente (royal + xadrez) ──
    var presente = this.faixa(
      "royal cp-checker",
      "",
      '<p class="cp-heading qd-presente__head">Por isso o presente não acaba quando ele abre a caixa.</p>' +
        '<p class="qd-presente__sub">Veja o que você também vai receber:</p>' +
        '<div class="qd-reveal">' +
        this.img_(this.caixa, "A caixa do presente Pé Direito", "qd-presente__caixa") +
        "</div>" +
        '<div class="qd-presente__blocos">' +
        this.missaoHTML() +
        this.capsulaHTML() +
        "</div>" +
        this.kitHTML(kit),
      "presente"
    );

    this.root.innerHTML =
      '<div class="qd-res">' +
      '<button type="button" class="qd-descer" data-descer aria-label="Ir para o presente">' +
      '<span class="qd-descer__label">Ver o presente</span>' +
      seta("down", "qd-anim-bounce", 2.5) +
      "</button>" +
      hero +
      manifesto +
      foto +
      transicao +
      diagnostico +
      solucao +
      presente +
      "</div>";

    // aplica delays de reveal
    var delayed = this.root.querySelectorAll("[data-reveal-delay]");
    Array.prototype.forEach.call(delayed, function (n) {
      n.style.transitionDelay = n.getAttribute("data-reveal-delay") + "ms";
    });

    var self = this;
    this.root
      .querySelector("[data-refazer]")
      .addEventListener("click", function () {
        self.respostas = {};
        self.idx = 0;
        self.mountQuiz();
        scrollTopo();
      });
    var add = this.root.querySelector("[data-add]");
    if (add) {
      add.addEventListener("click", function () {
        self.abrirModalKit(kit);
      });
    }

    // botão fixo "Ver o presente" — some quando a seção do presente aparece
    this.bindDescer();

    bindReveals(this.root);
    this.updateAddButton();
    scrollTopo();
  };

  Quiz.prototype.bindDescer = function () {
    var btn = this.root.querySelector("[data-descer]");
    var alvo = this.root.querySelector("#presente");
    if (!btn || !alvo) return;
    btn.addEventListener("click", function () {
      if (typeof alvo.scrollIntoView === "function") {
        alvo.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        btn.classList.toggle("is-visible", !entries[0].isIntersecting);
      },
      { rootMargin: "0px 0px -35% 0px" }
    );
    io.observe(alvo);
  };

  Quiz.prototype.missaoHTML = function () {
    return (
      '<div class="qd-reveal"><div class="qd-missao">' +
      pill("A missão É Coisa de Pai", "peri") +
      this.img_(this.scriptAzul, "", "qd-missao__script", true) +
      '<p class="qd-missao__text">Todo mês chega no seu e-mail uma missão pra vocês dois fazerem juntos, com atividades que estimulam esses momentos de qualidade. Em doze meses, são doze memórias que não existiriam se ninguém tivesse chamado.</p>' +
      lockup() +
      "</div></div>"
    );
  };

  Quiz.prototype.capsulaHTML = function () {
    var cartas = "";
    var giros = ["a", "b"];
    for (var g = 0; g < giros.length; g++) {
      cartas +=
        '<div class="qd-capsula__carta qd-capsula__carta--' +
        giros[g] +
        '"><div class="qd-capsula__carta-inner">' +
        '<div class="qd-capsula__line"></div>' +
        '<div class="qd-capsula__line"></div>' +
        '<div class="qd-capsula__line"></div>' +
        "</div></div>";
    }
    return (
      '<div class="qd-reveal"><div class="qd-capsula"><div class="qd-capsula__grid">' +
      '<div class="qd-capsula__render">' +
      this.img_(
        this.capsula,
        "Cápsula do tempo É Coisa de Pai — tubo xadrez azul e creme"
      ) +
      "</div>" +
      '<div class="qd-capsula__body">' +
      pill("A cápsula do tempo digital", "peri") +
      '<p class="qd-capsula__text">Uma cápsula do tempo com aprendizados e memórias pra vocês revisitarem no próximo Dia dos Pais. Em 2027 vocês leem juntos e veem o quanto mudou em um ano.</p>' +
      '<div class="qd-capsula__cartas" aria-hidden="true">' +
      cartas +
      "</div>" +
      "</div></div></div></div>"
    );
  };

  Quiz.prototype.kitHTML = function (kit) {
    // imagem do cartão: bloco da seção primeiro, senão o render padrão
    var cfgKit = this.kitConfig()[kit.id] || {};
    var cardImg = cfgKit.image || this.prod.azul;
    var cardAlt = cfgKit.imageAlt || kit.nome;

    var itens = "";
    for (var i = 0; i < kit.itens.length; i++) {
      itens += pill(kit.itens[i], "perisoft");
    }

    var cores = "";
    if (kit.escolheCor) {
      var swatches = [
        { src: this.prod.amarelo, alt: "Chinelo PéDireito amarelo" },
        { src: this.prod.verde, alt: "Chinelo PéDireito verde" },
        { src: this.prod.azul, alt: "Chinelo PéDireito azul" },
        { src: this.prod.branco, alt: "Chinelo PéDireito branco" },
      ];
      var sw = "";
      for (var s = 0; s < swatches.length; s++) {
        sw +=
          '<div class="qd-card__swatch">' +
          this.img_(swatches[s].src, swatches[s].alt) +
          "</div>";
      }
      cores =
        '<div class="qd-card__cores"><div class="qd-card__swatches">' +
        sw +
        "</div>" +
        '<p class="qd-card__cortxt">Você escolhe a cor do chinelo na finalização.</p></div>';
    }

    var precoDe = kit.precoDe
      ? '<span class="qd-card__de">' + formatarPreco(kit.precoDe) + "</span>"
      : "";
    var economia = kit.economia
      ? '<span class="qd-card__economia">' +
        pill("economize " + formatarReais(kit.economia), "peri") +
        "</span>"
      : "";

    return (
      '<div class="qd-reveal"><div class="qd-kit">' +
      pill("E o kit com a cara dele", "peri") +
      '<h2 class="cp-heading qd-kit__h2">é esse o presente certo</h2>' +
      '<div class="qd-card">' +
      '<div class="qd-card__render">' +
      this.img_(cardImg, cardAlt) +
      "</div>" +
      '<div class="qd-card__body">' +
      '<h3 class="cp-heading qd-card__name">' +
      esc(kit.nome) +
      "</h3>" +
      '<div class="qd-card__itens">' +
      itens +
      "</div>" +
      cores +
      '<div class="qd-card__precos">' +
      precoDe +
      '<span class="cp-heading qd-card__preco">' +
      formatarPreco(kit.preco) +
      "</span>" +
      economia +
      "</div>" +
      '<button type="button" class="qd-addcart" data-add></button>' +
      '<div data-add-note></div>' +
      "</div></div>" +
      '<button type="button" class="qd-refazer" data-refazer>Refazer o quiz</button>' +
      "</div></div>"
    );
  };

  Quiz.prototype.updateAddButton = function () {
    var add = this.root.querySelector("[data-add]");
    var note = this.root.querySelector("[data-add-note]");
    if (!add) return;
    if (this.adicionado) {
      add.classList.add("is-added");
      add.innerHTML = losango() + " Adicionado";
      if (note)
        note.innerHTML =
          '<p class="qd-addcart-note">Item adicionado ao seu carrinho.</p>';
    } else {
      add.classList.remove("is-added");
      add.innerHTML = "Adicionar ao carrinho";
      if (note) note.innerHTML = "";
    }
  };

  // ── Config dos kits (blocos da seção) ───────────────────────
  Quiz.prototype.kitConfig = function () {
    if (this._cfg) return this._cfg;
    var map = {};
    var nodes = this.root.querySelectorAll(".qd-kit-config");
    Array.prototype.forEach.call(nodes, function (node) {
      var id = node.getAttribute("data-kit-id");
      if (!id) return;
      var comps = [];
      try {
        comps = JSON.parse(node.textContent || "[]");
      } catch (e) {
        comps = [];
      }
      map[id] = {
        isAvulso: node.getAttribute("data-avulso") === "1",
        image: node.getAttribute("data-kit-image") || "",
        imageAlt: node.getAttribute("data-kit-image-alt") || "",
        extras: lerExtras(node),
        extrasLabel: lerExtrasLabel(node),
        components: comps,
      };
    });
    this._cfg = map;
    return map;
  };

  Quiz.prototype.abrirModalKit = function (kit) {
    var cfg = this.kitConfig()[kit.id];
    // Sem produtos configurados -> mantém o comportamento antigo (mock).
    if (!cfg || !cfg.components || !cfg.components.length) {
      this.adicionado = true;
      this.updateAddButton();
      return;
    }
    new KitModal(this, kit, cfg);
  };

  // data-extras="Tradição Coisa de Pai e Filho|Cápsula do tempo digital"
  // Vem do setting de tema settings.kit_extras — fonte única, compartilhada
  // com o carrinho (snippets/cart-products.liquid).
  function lerExtras(node) {
    var raw = node.getAttribute("data-extras") || "";
    return raw
      .split("|")
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  // Rótulo da line item property. Sem "_" na frente de propósito: propriedades
  // com underscore ficam ocultas no carrinho.
  function lerExtrasLabel(node) {
    return node.getAttribute("data-extras-label") || "Inclui";
  }

  // ── Modal de seleção de variantes (passo a passo por produto) ─
  function KitModal(quiz, kit, cfg) {
    this.quiz = quiz;
    this.kit = kit;
    this.cfg = cfg;
    this.comps = cfg.components;
    // Itens que acompanham o kit (Tradição, Cápsula do tempo). NÃO são
    // produtos: são só rótulos, exibidos no modal e gravados como line item
    // property visível pra aparecerem no carrinho.
    this.extras = cfg.extras || [];
    this.extrasLabel = cfg.extrasLabel || "Inclui";
    this.step = 0;
    this.selecionado = new Array(this.comps.length).fill(null); // variantId por componente
    this.prodIdx = new Array(this.comps.length).fill(null); // produto escolhido (ex.: cor do chinelo)
    this.escolhas = this.comps.map(function () {
      return [];
    }); // valores de opção (tamanho) escolhidos por componente
    this.adding = false;
    this.mount();
  }

  KitModal.prototype.mount = function () {
    var el = document.createElement("div");
    el.className = "qd-modal";
    el.innerHTML =
      '<div class="qd-modal__backdrop" data-close></div>' +
      '<div class="qd-modal__panel qd-sobe" role="dialog" aria-modal="true" aria-label="Monte seu presente">' +
      '<button type="button" class="qd-modal__x" data-close aria-label="Fechar">' +
      seta("x") +
      "</button>" +
      '<div class="qd-modal__head">' +
      '<p class="qd-modal__kicker">Monte seu presente</p>' +
      '<p class="qd-modal__progress" data-progress></p>' +
      "</div>" +
      '<div class="qd-modal__body" data-body></div>' +
      '<p class="qd-modal__erro" data-erro hidden></p>' +
      '<div class="qd-modal__foot">' +
      '<button type="button" class="qd-modal__back" data-back></button>' +
      '<button type="button" class="qd-modal__next" data-next></button>' +
      "</div>" +
      "</div>";
    this.el = el;
    this.quiz.root.appendChild(el);
    document.documentElement.classList.add("qd-modal-open");

    var self = this;
    Array.prototype.forEach.call(
      el.querySelectorAll("[data-close]"),
      function (b) {
        b.addEventListener("click", function () {
          self.fechar();
        });
      }
    );
    this._onKey = function (e) {
      if (e.key === "Escape") self.fechar();
    };
    document.addEventListener("keydown", this._onKey);
    el.querySelector("[data-back]").addEventListener("click", function () {
      self.voltar();
    });
    el.querySelector("[data-next]").addEventListener("click", function () {
      self.avancar();
    });

    this.render();
  };

  KitModal.prototype.fechar = function () {
    if (this._onKey) document.removeEventListener("keydown", this._onKey);
    document.documentElement.classList.remove("qd-modal-open");
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
  };

  KitModal.prototype.render = function () {
    var comp = this.comps[this.step];
    var total = this.comps.length;
    var ehUltimo = this.step === total - 1;
    var el = this.el;
    var products = comp.products || [];
    var multi = products.length > 1;

    el.querySelector("[data-progress]").textContent =
      "Produto " + (this.step + 1) + " de " + total;

    // produto default do passo (1º com variante disponível)
    if (this.prodIdx[this.step] == null) {
      var pi = 0;
      for (var pp = 0; pp < products.length; pp++) {
        if (temDisponivel(products[pp])) {
          pi = pp;
          break;
        }
      }
      this.prodIdx[this.step] = pi;
    }
    var prod = products[this.prodIdx[this.step]] || { options: [], variants: [] };
    var options = prod.options || [];
    var variants = prod.variants || [];
    var semSelecao = !options.length || variants.length <= 1;

    // pré-seleciona a 1ª variante disponível do produto atual
    if (!this.escolhas[this.step] || !this.escolhas[this.step].length) {
      var pre = primeiraDisponivel(variants) || variants[0] || null;
      this.escolhas[this.step] = pre ? (pre.options || []).slice() : [];
    }

    var self = this;
    var imgHtml = prod.image
      ? '<div class="qd-modal__imgwrap"><img class="qd-modal__img" src="' +
        esc(prod.image) +
        '" alt="' +
        esc(prod.title || "") +
        '" loading="lazy"></div>'
      : "";
    var body =
      '<div class="qd-modal__prod">' +
      imgHtml +
      '<h3 class="cp-heading qd-modal__prodtitle">' +
      esc(comp.label || prod.title || "") +
      "</h3>";

    // seletor de produto (ex.: cor do chinelo — cada cor é um produto)
    if (multi) {
      body +=
        '<div class="qd-modal__opt"><span class="qd-modal__optname">' +
        esc(comp.chooseLabel || "Opção") +
        '</span><div class="qd-modal__vals">';
      for (var pj = 0; pj < products.length; pj++) {
        var ativoP = this.prodIdx[this.step] === pj;
        var disp = temDisponivel(products[pj]);
        body +=
          '<button type="button" class="qd-modal__val' +
          (ativoP ? " is-active" : "") +
          (disp ? "" : " is-off") +
          '" data-prod="' +
          pj +
          '">' +
          esc(products[pj].title || "") +
          "</button>";
      }
      body += "</div></div>";
    }

    // seletor de tamanho (variantes do produto atual)
    if (semSelecao) {
      body += '<p class="qd-modal__single">Tamanho único</p>';
    } else {
      for (var oi = 0; oi < options.length; oi++) {
        body +=
          '<div class="qd-modal__opt"><span class="qd-modal__optname">' +
          esc(options[oi]) +
          '</span><div class="qd-modal__vals">';
        var vals = valoresDeOpcao(variants, oi);
        for (var vi = 0; vi < vals.length; vi++) {
          var val = vals[vi];
          var ativo = this.escolhas[this.step][oi] === val;
          body +=
            '<button type="button" class="qd-modal__val' +
            (ativo ? " is-active" : "") +
            '" data-opt="' +
            oi +
            '" data-val="' +
            esc(val) +
            '">' +
            esc(val) +
            "</button>";
        }
        body += "</div></div>";
      }
    }
    // Itens que acompanham o kit — só informativo, sem seleção. Aparecem no
    // último passo, que é o momento de confirmar o que vai pro carrinho.
    if (ehUltimo && this.extras.length) {
      body +=
        '<div class="qd-modal__inclusos">' +
        '<span class="qd-modal__optname">Já incluso no kit</span><ul>';
      for (var ai = 0; ai < this.extras.length; ai++) {
        body +=
          '<li class="qd-modal__incluso">' +
          '<span class="qd-modal__incluso-mark" aria-hidden="true"></span>' +
          "<span>" +
          esc(this.extras[ai]) +
          "</span></li>";
      }
      body += "</ul></div>";
    }

    body += "</div>";

    var bodyEl = el.querySelector("[data-body]");
    bodyEl.innerHTML = body;

    Array.prototype.forEach.call(
      bodyEl.querySelectorAll("[data-prod]"),
      function (b) {
        b.addEventListener("click", function () {
          self.prodIdx[self.step] = Number(b.getAttribute("data-prod"));
          self.escolhas[self.step] = []; // reseta o tamanho ao trocar de produto
          self.render();
        });
      }
    );
    Array.prototype.forEach.call(
      bodyEl.querySelectorAll("[data-val]"),
      function (b) {
        b.addEventListener("click", function () {
          self.escolhas[self.step][Number(b.getAttribute("data-opt"))] =
            b.getAttribute("data-val");
          self.render();
        });
      }
    );

    // resolve a variante do produto atual para os valores escolhidos
    var v = semSelecao
      ? variants[0] || null
      : resolverVariante(variants, this.escolhas[this.step]);
    this.selecionado[this.step] = v && v.available ? v.id : null;

    var back = el.querySelector("[data-back]");
    back.textContent = this.step === 0 ? "Cancelar" : "Voltar";

    var next = el.querySelector("[data-next]");
    var ok = !!this.selecionado[this.step] && !this.adding;
    next.innerHTML =
      (ehUltimo ? "Adicionar ao carrinho" : "Confirmar") + seta("right");
    next.disabled = !ok;
    next.classList.toggle("is-disabled", !ok);

    var erro = el.querySelector("[data-erro]");
    if (!v) {
      erro.textContent = "Selecione uma combinação.";
      erro.hidden = false;
    } else if (!v.available) {
      erro.textContent = "Essa opção está indisponível.";
      erro.hidden = false;
    } else {
      erro.hidden = true;
      erro.textContent = "";
    }
  };

  KitModal.prototype.voltar = function () {
    if (this.step === 0) {
      this.fechar();
      return;
    }
    this.step -= 1;
    this.render();
  };

  KitModal.prototype.avancar = function () {
    if (!this.selecionado[this.step] || this.adding) return;
    if (this.step < this.comps.length - 1) {
      this.step += 1;
      this.render();
      return;
    }
    this.finalizar();
  };

  KitModal.prototype.finalizar = function () {
    var self = this;
    this.adding = true;
    var next = this.el.querySelector("[data-next]");
    next.disabled = true;
    next.classList.add("is-disabled");
    next.textContent = "Adicionando...";

    // animação "voando pro carrinho" (igual buy-buttons)
    flyToCart(next, self.quiz.prod && self.quiz.prod.azul);

    var grupo = uid();
    var items = this.comps.map(function (c, i) {
      var it = { id: self.selecionado[i], quantity: 1 };
      if (!self.cfg.isAvulso) {
        it.properties = { _kit_id: self.kit.id, _kit_group: grupo };
      }
      return it;
    });

    // Itens que acompanham o kit: NÃO são produtos — viram uma line item
    // property visível (nome sem "_"), que o carrinho renderiza como texto
    // sob o item. Vai só na primeira linha pra não repetir em cada componente.
    if (this.extras.length && items[0]) {
      items[0].properties = items[0].properties || {};
      items[0].properties[this.extrasLabel] = this.extras.join(" • ");
    }

    nativeAddToCart(this.quiz.root, items).then(
      function () {
        self.fechar();
        self.quiz.adicionado = true;
        self.quiz.updateAddButton();
      },
      function (err) {
        self.adding = false;
        var erro = self.el.querySelector("[data-erro]");
        erro.textContent =
          (err && err.message) || "Não foi possível adicionar. Tente novamente.";
        erro.hidden = false;
        self.render();
      }
    );
  };

  function temDisponivel(prod) {
    var vs = (prod && prod.variants) || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return true;
    return false;
  }

  function primeiraDisponivel(variants) {
    for (var i = 0; i < variants.length; i++)
      if (variants[i].available) return variants[i];
    return null;
  }

  // valores distintos de uma opção (posição oi) entre as variantes
  function valoresDeOpcao(variants, oi) {
    var out = [],
      seen = {};
    for (var i = 0; i < variants.length; i++) {
      var val = (variants[i].options || [])[oi];
      if (val != null && !seen[val]) {
        seen[val] = true;
        out.push(val);
      }
    }
    return out;
  }

  // variante cujas opções batem exatamente com as escolhidas
  function resolverVariante(variants, escolhidas) {
    for (var i = 0; i < variants.length; i++) {
      var opts = variants[i].options || [];
      if (opts.length !== escolhidas.length) continue;
      var match = true;
      for (var j = 0; j < escolhidas.length; j++) {
        if (opts[j] !== escolhidas[j]) {
          match = false;
          break;
        }
      }
      if (match) return variants[i];
    }
    return null;
  }

  function uid() {
    return "k" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  // ── Add-to-cart nativo (abre o cart drawer, SEM redirecionar para /cart) ─
  function nativeAddToCart(rootEl, items) {
    var routes = (window.Theme && window.Theme.routes) || {};
    var addUrl = routes.cart_add_url || "/cart/add.js";

    var sectionIds = Array.prototype.map
      .call(document.querySelectorAll("cart-items-component"), function (el) {
        return el.dataset ? el.dataset.sectionId : null;
      })
      .filter(Boolean);

    return fetch(addUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items, sections: sectionIds.join(",") }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response && response.status) {
          throw new Error(
            response.description ||
              response.message ||
              "Não foi possível adicionar ao carrinho."
          );
        }
        var srcId = items[0] ? String(items[0].id) : "";
        var count = items.reduce(function (s, i) {
          return s + (i.quantity || 1);
        }, 0);
        var target = rootEl || document.body;
        // Abre/atualiza o cart drawer via o evento do tema. NUNCA redireciona.
        return notifyCartAdd(target, srcId, count, response.sections).then(
          function () {
            return { ok: true };
          }
        );
      });
  }

  // Dispara o evento de "item adicionado" que o tema Horizon escuta
  // (CartAddEvent de @theme/events → cart-drawer abre e atualiza pelas sections).
  function notifyCartAdd(target, srcId, count, sections) {
    return import("@theme/events").then(
      function (m) {
        if (m && m.CartAddEvent) {
          target.dispatchEvent(
            new m.CartAddEvent({}, srcId, {
              source: "quiz-dia-dos-pais",
              itemCount: count,
              sections: sections,
            })
          );
          return;
        }
        firePlainCartUpdate(target, sections);
      },
      function () {
        firePlainCartUpdate(target, sections);
      }
    );
  }

  // Fallback: se @theme/events não resolver, ainda abre o drawer (evento
  // 'cart:update') e atualiza o conteúdo do carrinho via fetchCartData.
  function firePlainCartUpdate(target, sections) {
    try {
      target.dispatchEvent(
        new CustomEvent("cart:update", {
          bubbles: true,
          detail: { data: { source: "quiz-dia-dos-pais", sections: sections } },
        })
      );
    } catch (e) {}
    refreshCart("/cart").catch(function () {});
  }

  // Animação "voando pro carrinho" (igual buy-buttons / product-form do tema).
  function flyToCart(sourceBtn, imageUrl) {
    var cartIcon = document.querySelector(".header-actions__cart-icon");
    if (!cartIcon || !sourceBtn || !imageUrl) return;
    import("@theme/fly-to-cart").then(
      function () {
        try {
          var fly = document.createElement("fly-to-cart");
          fly.classList.add("fly-to-cart--main");
          fly.style.setProperty("background-image", "url(" + imageUrl + ")");
          fly.style.setProperty("--start-opacity", "0");
          fly.source = sourceBtn;
          fly.destination = cartIcon;
          document.body.appendChild(fly);
        } catch (e) {}
      },
      function () {}
    );
  }

  function refreshCart(cartUrl) {
    var cic = document.querySelector("cart-items-component");
    if (cic && typeof cic.fetchCartData === "function") {
      return customElements
        .whenDefined("cart-items-component")
        .then(function () {
          return cic.fetchCartData();
        });
    }
    return fetch(cartUrl + ".js", { headers: { Accept: "application/json" } }).then(
      function (r) {
        return r.json();
      }
    );
  }

  // ── Bootstrap ───────────────────────────────────────────────
  function initRoot(root) {
    if (!root || root.getAttribute("data-quiz-init") === "1") return;
    root.setAttribute("data-quiz-init", "1");
    new Quiz(root);
  }
  function scan(scope) {
    var nodes = (scope || document).querySelectorAll("[data-quiz-root]");
    Array.prototype.forEach.call(nodes, initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scan();
    });
  } else {
    scan();
  }

  // editor da Shopify: re-inicializa a seção recarregada
  document.addEventListener("shopify:section:load", function (e) {
    scan(e.target || document);
  });

  // ── Global Helper: Abrir Modal do Kit de qualquer lugar ─────
  window.openKitModal = function (kitId, rootEl) {
    var root = rootEl || document;
    var script =
      root.querySelector('.qd-kit-config[data-kit-id="' + kitId + '"]') ||
      document.querySelector('.qd-kit-config[data-kit-id="' + kitId + '"]');
    if (!script) {
      console.warn("qd-kit-config não encontrado para kitId:", kitId);
      return;
    }
    var comps = [];
    try {
      comps = JSON.parse(script.textContent || "[]");
    } catch (e) {
      comps = [];
    }
    var cfg = {
      isAvulso: script.getAttribute("data-avulso") === "1",
      image: script.getAttribute("data-kit-image") || "",
      imageAlt: script.getAttribute("data-kit-image-alt") || "",
      extras: lerExtras(script),
      extrasLabel: lerExtrasLabel(script),
      components: comps,
    };
    var dummyQuiz = {
      root: (root.closest && root.closest("[data-quiz-root]")) || document.body,
      adicionado: false,
      updateAddButton: function () {},
    };
    new KitModal(dummyQuiz, { id: kitId }, cfg);
  };

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-open-kit-modal]");
    if (!btn) return;
    e.preventDefault();
    var kitId = btn.getAttribute("data-open-kit-modal") || btn.getAttribute("data-kit-id");
    if (kitId) {
      window.openKitModal(kitId, btn);
    }
  });
})();

